import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SnCurrentOrganization } from '@lib/auth';

@Component({
  template: '',
  selector: 'sn-plates-redirect',
})
export class PlatesRedirectComponent implements OnInit {
  constructor(private readonly _router: Router) {}

  ngOnInit(): void {
    const redirectPath = '/plates/list/search';
    this._router.navigate([redirectPath], { replaceUrl: true });
  }
}
